var exports = {
  "xE": "WarningAlert.module__alert___dk85UH",
  "Kk": "WarningAlert.module__icon___dk85UH",
  "Qs": "WarningAlert.module__content___dk85UH",
  "DD": "WarningAlert.module__title___dk85UH",
  "Qq": "WarningAlert.module__text___dk85UH",
  "nf": "WarningAlert.module__link___dk85UH",
  "o1": "WarningAlert.module__actions___dk85UH",
};

module.exports = exports;
